import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class PrevetListItem extends Component {
    static propTypes = {
        item: PropTypes.shape({
            legalName: PropTypes.string,
            id: PropTypes.string,
            onboardingId: PropTypes.string,
            decisionOutcome: PropTypes.string
        }),
        onGoToItem: PropTypes.func.isRequired
    };

    renderMerchantName(legalName) {
        return legalName;
    }

    renderPreVetResult(decisionOutcome) {
        return decisionOutcome;
    }

    render() {
        const prevet = this.props.item;

        return (
            <div
                className="list-item"
                onClick={() => this.props.onGoToItem(prevet)}
            >
                <div className="list-item-left">
                    <span className="prevet-merchantName">
                        {this.renderMerchantName(prevet.legalName)}
                    </span>
                    <span className="prevet-result">
                        {this.renderPreVetResult(prevet.decisionOutcome)}
                    </span>
                </div>
                <div className="list-item-right">
                    <span className="prevet-id">
                        {prevet.id}
                    </span>
                </div>
            </div>
        );
    }
}
